import { Link } from "react-router-dom";
import { Moon } from "lucide-react";
import StarCanvas from "@/components/StarCanvas";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="relative min-h-screen bg-[#0B091A] overflow-x-clip flex items-center justify-center px-4">
      <StarCanvas />
      <div className="relative z-10 glass-card rounded-3xl p-10 sm:p-12 max-w-md w-full text-center">
        <Moon size={36} className="text-purple-400 mx-auto mb-5" />
        <h1 className="font-serif text-2xl sm:text-3xl font-bold text-white mb-2">This page drifted off to sleep</h1>
        <p className="text-sm text-slate-400 mb-8">We couldn't find that page. Let's get you back to the stories.</p>
        <Link
          data-testid="not-found-home-link"
          to="/"
          className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-gradient-to-r from-purple-600 to-amber-500 text-white font-semibold text-sm hover:shadow-lg hover:shadow-purple-500/30 transition-all"
        >
          Back to DreamWeaver
        </Link>
      </div>
    </div>
  );
}
